<template>
  <router-link :to="{ name: 'ViewSubmission', params: { id: report.submission_id } }" class="report-card">
    <h3 class="report-title">{{ report.comment }}</h3>
    <div class="report-meta">
      <SeverityLabel v-if="report.severity_level" :severity="Number(report.severity_level)" />
      <span v-if="place" class="report-place"><i class="fas fa-location-dot" aria-hidden="true"></i> {{ place }}</span>
      <span v-if="detailed && report.submitter" class="report-by">{{ $t('explore.submittedBy') }} {{ report.submitter }}</span>
    </div>
    <ul v-if="labels.length" class="report-labels" :aria-label="$t('explore.labels')">
      <li v-for="label in labels" :key="label">{{ $label(label) }}</li>
    </ul>
  </router-link>
</template>

<script>
import SeverityLabel from '@/components/SeverityLabel.vue';

export default {
  name: 'ReportCard',
  components: { SeverityLabel },
  props: {
    report: { type: Object, required: true },
    detailed: { type: Boolean, default: false },
  },
  computed: {
    place() {
      return [this.report.city, this.report.region].map(s => (s || '').trim()).filter(Boolean).join(', ');
    },
    labels() {
      return [...new Set((this.report.all_labels || []).map(l => l && l.label).filter(Boolean))].slice(0, 4);
    },
  },
};
</script>

<style scoped>
/* One element per report: the card is the link. */
.report-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  color: inherit;
  text-align: left;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-card);
  transition: box-shadow .2s ease, border-color .2s ease;
}
.dark-mode .report-card { color: var(--color-text-light); }
.report-card:hover { box-shadow: var(--shadow-card-hover); border-color: var(--color-primary); }
.report-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.report-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 12px; font-size: 14px; color: var(--color-secondary); }
.dark-mode .report-meta { color: var(--color-text-light); }
.report-labels { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 6px; }
.report-labels li { padding: 4px 10px; font-size: 12px; border-radius: var(--radius-pill); background: var(--color-subtle); color: var(--color-text); }
.dark-mode .report-labels li { color: var(--color-text-light); }
</style>
